import { cx } from './cx'

type SpinnerProps = {
  size?: 'sm' | 'md' | 'lg'
  /** Announced to screen readers. Omit when the surrounding control already says it is busy. */
  label?: string
}

const sizes = { sm: 'size-4', md: 'size-5', lg: 'size-8' }

export function Spinner({ size = 'md', label }: SpinnerProps) {
  const svg = (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      aria-hidden="true"
      data-motion="essential"
      className={cx(sizes[size], 'animate-spin text-current')}
    >
      <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="2.5" className="opacity-20" />
      <path d="M21 12a9 9 0 0 0-9-9" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" />
    </svg>
  )
  if (!label) return svg
  return (
    <output className="inline-flex items-center gap-2 text-ink-2">
      {svg}
      <span className="sr-only">{label}</span>
    </output>
  )
}
